import React, { ReactNode } from 'react';
import { Heading3 } from '@ovotech/element-v4';
import styles from './FormSection.module.css';

type FormSectionProps = {
  id: string;
  title: string;
  children: ReactNode;
  description?: string;
  className?: string;
};

export const FormSection = ({
  id,
  title,
  description,
  className,
  children,
}: FormSectionProps) => {
  return (
    <div className={className} data-testid={id}>
      <Heading3 className={styles.title}>{title}</Heading3>

      {description && <div className={styles.description}>{description}</div>}

      {children}
    </div>
  );
};
